import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from "@material-ui/core";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { DialogPdf, ButtonHLPure, ChatBoxGLPure } from '../../pures';
import { newProfileIcon } from '../../../assets/logos/icons';

const ChatAndDocumentView = (props) => {
    const { t } = useTranslation();

    let { 
        blob,
        showBackBtn,
        onHandleReject,
        documentSelected,
        handleChangeScreen,
        nameElement,
        usersChat,
        conversation,
        handleInputChangeChat,
        createMessage,
        membersChat
    } = props  

    return (
        <>
            {
                nameElement === 'document' ? (
                    <div className="pdf-btn">
                        <DialogPdf blobUrl={blob} />
                    </div>
                ) : (
                    <>
                        <Grid className="validateRepseDocumentView-headerUsersChat">
                            <span className="validateRepseDocumentView-titleGrid">
                                {t("validateRepseDocuments.chat.title")}
                            </span>
                            <div className="validateRepseDocumentView-containersAvatars">
                                {membersChat.map((item, index) => (
                                    <div>
                                        <Tooltip
                                            openDelay={600}
                                            position="bottom"
                                            anchorElement="target"
                                            tooltipClassName="tooltipGeneralStyle"
                                        >
                                            <div>
                                                <img
                                                    title={item.name}
                                                    key={index}
                                                    src={
                                                        item.avatarUrl && item.avatarUrl !== ""
                                                            ? item.avatarUrl
                                                            : newProfileIcon
                                                    }
                                                    className="followUpActionsContractsView-avatar"
                                                    alt={item.name}
                                                />
                                            </div>
                                        </Tooltip>
                                    </div>
                                ))}
                            </div>
                        </Grid>
                        <ChatBoxGLPure
                            user={usersChat}
                            conversation={conversation}
                            widthChat={1200}
                            heightChat={300}
                            placeholderChat={t("chatBoxGLPure.placeholder")}
                            handleInputChange={handleInputChangeChat}
                            createMessage={createMessage}
                        />
                    </>
                )
                
            }
            
            {   
                (showBackBtn && nameElement === 'document') ? (
                    <ButtonHLPure
                        nameBtn={t("validateRepseDocuments.btn.reject.doc")}
                        primary={false}
                        onClickBtn={() => onHandleReject(documentSelected)}
                    />
                ) : null
            }
            <ButtonHLPure
                nameBtn={t("signatureProfilesDetailsView.back")}
                primary={false}
                onClickBtn={() => handleChangeScreen(true)}
            />
        </>
    )
}

export default ChatAndDocumentView